<div class="container-fluid px-2">
  <app-pagetitle title="Supervisor Mapping" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row" *ngIf="departments.length != 0">
    <div class="form-group col-md-3">
      <label class="control-label">Select Department</label>
      <select class="form-control" email="departmentName" id="departmentName"
       [(ngModel)]="selecteddepartmentName"
        (change)="departmentChange($event.target.value)" style="color: #000">
        <!-- <option value="" selected disabled>Select Machine</option> -->
        <option [value]="line.departmentName" *ngFor="let line of departments">
          {{ line.departmentName }}
        </option>
      </select>
    </div>
  </div>

  <div class="row" *ngIf="departments.length != 0">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body p-2">
          <div style="overflow-x: auto; width: 100%;">
            <table class="table table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0" style="min-width: 600px;">
              <thead class="table-dark">
                <tr>
                  <th scope="col">Departments</th>
                  <th scope="col" *ngFor="let shift of selectedDept?.mappedData">{{ shift.shiftName }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ selecteddepartmentName }}</td>
                  <td *ngFor="let shift of selectedDept?.mappedData">
                    <select class="form-select form-select-sm form-control"
                      [(ngModel)]="selectedSupervisors[shift.shiftName]"
                      style="width: 200px;" (change)="onSupervisorChange($event, shift.shiftName)">
                      <option *ngFor="let supervisor of supervisors" [value]="supervisor.email">
                        {{ supervisor.name }}
                      </option>
                      <!-- [ngClass]="{
                       'border-success': selectedSupervisors[shift.shiftName] !== 'Not Mapped',
                       'border-danger': selectedSupervisors[shift.shiftName] === 'Not Mapped'
                     }" -->
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" *ngIf="departments.length == 0">
    <span><strong>No Department Found. Please Add Department</strong></span>
  </div>
</div>
